import { apiClient } from "@/utils/axios";

export function setApiShopCode(code: string | null) {
  if (code) {
    apiClient.defaults.headers.common["x-shop-code"] = code;
  } else {
    delete apiClient.defaults.headers.common["x-shop-code"];
  }
}

export { apiClient as api };

